import { put } from "redux-saga/effects";
import { message } from "antd";

import ActivityApiCaller from "../../config/api/activityapicaller";

import { ShortlistAction } from "../actions";

export default class ShortlistMiddleware {
  static *getShortlist({ payload, cb }) {
    try {
      const action =
        payload?.filter === "Shortlisted Me" ? "receiver" : "sender";

      const res = yield ActivityApiCaller.Get(
        `/activity/shortlist/${action}?sort=${payload.sort ?? ""}`
      );

      if (res?.status === 200) {
        yield put(ShortlistAction.getShortlistSuccess(res.data?.data));
      } else {
        yield put(ShortlistAction.getShortlistFailure());
      }
      if (cb) {
        cb(res.data?.data);
      }
    } catch (err) {
      yield put(ShortlistAction.getShortlistFailure());
    }
  }
  static *getShortlistAll({ cb }) {
    try {
      const res = yield ActivityApiCaller.Get(`/activity/shortlist/all`);
      if (res?.status === 200) {
        yield put(ShortlistAction.getShortlistAllSuccess(res?.data?.data));
      } else {
        yield put(ShortlistAction.getShortlistAllFailure());
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(ShortlistAction.getShortlistAllFailure());
    }
  }
  static *sendShortlist({ payload, cb }) {
    try {
      const res = yield ActivityApiCaller.Post("/activity/shortlist", payload);

      if (res.status === 200) {
        message.success(res.data.message);
        yield put(ShortlistAction.sendShortlistSuccess(res.data?.data));
        yield put(ShortlistAction.getShortlistAll());
      } else {
        message.error(res.data.message);
        yield put(ShortlistAction.sendShortlistFailure());
      }
      if (cb) {
        cb(res.data?.data);
      }
    } catch (err) {
      message.error("Something went wrong. Please try again.");
      yield put(ShortlistAction.sendShortlistFailure());
    }
  }
}
